import { render, staticRenderFns } from "./MaterialHeader.vue?vue&type=template&id=ec8bbef0&scoped=true&"
import script from "./MaterialHeader.vue?vue&type=script&lang=js&"
export * from "./MaterialHeader.vue?vue&type=script&lang=js&"
import style0 from "./MaterialHeader.vue?vue&type=style&index=0&id=ec8bbef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8bbef0",
  null
  
)

export default component.exports